import { styled } from 'styled-components';

export const StyleWalletIconContainer = styled.div<{ width: number; height: number }>`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    border-radius: 5px;
    overflow: hidden;
  }
`;

export const StyleAAWrapper = styled.div`
  position: relative;
  height: 28px;
  align-items: center;
  display: flex;
`;

export const StyleCMWrapper = styled.div<{ width: number; height: number }>`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  background: var(--pcm-body-background);
  border-radius: 100%;
  padding: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -20%;
  bottom: -2%;
  & > svg {
    width: 100%;
    height: 100%;
  }
`;
